const BASE_KEY = 'settings.devices.eap-settings.eap-config-list.action.delete';

export const DELETE_MODAL_KEY = {
    title: {
        one: `${BASE_KEY}.modal.title.one`,
        multiple: `${BASE_KEY}.modal.title.multiple`,
    },
    button: `${BASE_KEY}.modal.button`,
    notification: {
        success: `${BASE_KEY}.notification.success`,
        error: `${BASE_KEY}.notification.error`,
    },
} as const;

export const PREVENT_DELETE_KEY = {
    description: {
        one: `${BASE_KEY}.prevent.description.one`,
        multiple: `${BASE_KEY}.prevent.description.multiple`,
    },
} as const;

export const DESCRIPTION_BASE_KEY = `${BASE_KEY}.modal.description`;

export type DescriptionResult = {
    key: string;
    params: Record<string, string | number>;
};
